import EventBus from "@/libs/event-bus";
import events from "@/libs/events";

// Sanctum SPA-авторизация: axios проставляет X-XSRF-TOKEN автоматически, для fetch делаем это сами
const readXsrfToken = () => {
    const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
};

export default {
    /**
     * Отправить сообщение ассистенту и читать NDJSON-стрим событий.
     *
     * onEvent(event) вызывается на каждое событие стрима:
     *   {type: 'status', tool}      — инструмент запущен
     *   {type: 'action', action}    — инструмент завершён
     *   {type: 'delta', text}       — кусочек текста ответа
     *   {type: 'done', reply, actions} — финал (возвращается из метода)
     *   {type: 'error', message}    — ошибка (метод бросает исключение)
     */
    async sendMessageStream(api, projectId, message, file, onEvent) {
        const headers = {'X-Requested-With': 'XMLHttpRequest'};
        let body;
        if (file) {
            body = new FormData();
            body.append("message", message);
            body.append("reference", file);
        } else {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify({message});
        }
        const xsrf = readXsrfToken();
        if (xsrf) {
            headers['X-XSRF-TOKEN'] = xsrf;
        }

        const response = await fetch(api.send.fullPath('projects/' + projectId + '/ai/chat'), {
            method: 'POST',
            credentials: 'include',
            headers,
            body,
        });

        if (!response.ok || !response.body) {
            const data = await response.json().catch(() => null);
            if (response.status === 401) {
                EventBus.$emit(events.STATUS_401_UNAUTHORIZED);
            }
            const error = new Error(data?.message || 'Не удалось получить ответ ассистента. Попробуйте ещё раз.');
            error.response = {status: response.status, data};
            throw error;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let doneEvent = null;
        let errorEvent = null;

        for (;;) {
            const {value, done} = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {stream: true});
            let eol;
            while ((eol = buffer.indexOf('\n')) >= 0) {
                const line = buffer.slice(0, eol).trim();
                buffer = buffer.slice(eol + 1);
                if (!line) continue;
                let event;
                try {
                    event = JSON.parse(line);
                } catch (e) {
                    continue; // неполный JSON — дожидаемся следующего чанка
                }
                if (event.type === 'done') doneEvent = event;
                if (event.type === 'error') errorEvent = event;
                onEvent(event);
            }
        }

        if (errorEvent) {
            const error = new Error(errorEvent.message || 'Ассистент завершился с ошибкой.');
            error.code = errorEvent.code || null;
            error.retryable = !!errorEvent.retryable;
            throw error;
        }
        if (!doneEvent) {
            throw new Error('Ответ ассистента оборвался. Попробуйте ещё раз.');
        }
        return doneEvent;
    },

    history(api, projectId){
        return api.send.get('projects/' + projectId + '/ai/history');
    },

    clear(api, projectId){
        return api.send.delete('projects/' + projectId + '/ai/history');
    },

    backgroundVersions(api, projectId){
        return api.send.get('projects/' + projectId + '/background-assets');
    },

    applyBackground(api, projectId, assetId){
        return api.send.post(`projects/${projectId}/background-assets/${assetId}/apply`);
    },

    restoreBackground(api, projectId, assetId){
        return api.send.post(`projects/${projectId}/background-assets/${assetId}/restore`);
    },

    createBackgroundVariation(api, projectId, assetId){
        return api.send.post(`projects/${projectId}/background-assets/${assetId}/variation`);
    },

    deleteBackgroundCandidate(api, projectId, assetId){
        return api.send.delete(`projects/${projectId}/background-assets/${assetId}`);
    },
};
